module.exports = __webpack_public_path__ + "media/images/captive_portal/Color-Seven-ac0e39c3b04e777d392a7eda3c3b4f8a.png";